import axios from 'axios'

const getLanguage = () => localStorage.getItem("lang") || localStorage.getItem("i18nextLng") || "ar";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_EMPLOY}`,
    headers: {
        'platform': "agent",
   
        'Content-type': 'application/json'
    }
});

api.interceptors.request.use((config) => {
    const language = getLanguage();
    config.headers = config.headers || {};
    config.headers["Accept-Language"] = language;
    config.headers.language = language;
    return config;
});

export default api;

